/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/pages/marketing/CampaignProductsPage.tsx
 * ----------------------------------------------------------------------------
 * Lista de produtos de campanha (campanha ↔ produto ↔ armazém).
 *
 * Objetivo:
 * - Mostrar, para cada produto, o volume previsto e flags logísticas que
 *   impactam stock, slotting e priorização de trabalho.
 * - Endpoint: /api/marketing/campaign-products/
 *
 * Campos esperados no payload da API:
 *   id
 *   campaign_code        → código da campanha
 *   product_code         → código do produto
 *   product_name         → descrição do produto
 *   warehouse_code       → código do armazém (opcional)
 *   expected_orders      → nº previsto de pedidos
 *   expected_lines       → nº previsto de linhas
 *   expected_qty_units   → quantidade prevista (unidades)
 *   peak_date_from       → início do pico (opcional)
 *   peak_date_to         → fim do pico (opcional)
 *   priority_receiving   → bool
 *   priority_picking     → bool
 * ========================================================================== */

import CrudList from "@/components/CrudList";

export default function CampaignProductsPage() {
    return (
        <div className="p-4 md:p-6 space-y-4">
            <div className="max-w-4xl text-sm opacity-70">
                Visão consolidada dos produtos incluídos em campanhas: volumes
                previstos, armazéns impactados, janelas de pico e prioridades
                de receção/picking. Útil para planeamento de stock, slotting e
                capacidade operacional.
            </div>

            <CrudList
                title="Produtos de campanha"
                endpoint="/api/marketing/campaign-products/"
                columns={[
                    {
                        key: "campaign_code",
                        header: "Campanha",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "product_code",
                        header: "Produto",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "product_name",
                        header: "Descrição",
                        className: "min-w-[260px]",
                    },
                    {
                        key: "warehouse_code",
                        header: "Armazém",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "expected_orders",
                        header: "Pedidos prev.",
                        className: "text-right",
                    },
                    {
                        key: "expected_lines",
                        header: "Linhas prev.",
                        className: "text-right",
                    },
                    {
                        key: "expected_qty_units",
                        header: "Qtd. prev.",
                        className: "text-right",
                    },
                    {
                        key: "peak_date_from",
                        header: "Pico de",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "peak_date_to",
                        header: "Pico até",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "priority_receiving",
                        header: "Priorizar receção",
                        className: "whitespace-nowrap",
                    },
                    {
                        key: "priority_picking",
                        header: "Priorizar picking",
                        className: "whitespace-nowrap",
                    },
                ]}
            />
        </div>
    );
}
